<template lang="pug">
.option(:class='[classVertical]')
  slot
</template>
      
      <script>
export default {
  name: 'km-radio-auto',
  created() {},
  props: {
    show: {
      default: true,
    },
    oneRow: {
      default: false,
    },
    width: {
      default: 0,
    },
    hideTwoRow: {
      default: false,
    },
  },
  data() {
    return {
      classVertical: '',
      DOMParser: new DOMParser(),
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(v) {
        if (v) {
          if (this.oneRow) {
            this.classVertical = 'onerow'
          } else {
            this.$nextTick(() => {
              this.tryTime = 10
              this.autoOptionHeight()
            })
          }
        }
      },
    },
  },
  methods: {
    autoOptionHeight: function () {
      this.tryTime--
      const width = this.$el.getBoundingClientRect().width || this.width

      if (width === 0 && this.tryTime > 0) {
        setTimeout(() => {
          this.autoOptionHeight()
        })
        return
      }
      let levelAll = Math.floor(width / this.$slots.default.length) - 20
      let level2 = Math.floor(width / 2) - 20
      let options = this.$slots.default
      let classVertical = 'allrow'
      //   let classVertical = 'tworow'
      for (let j = 0; j < options.length; j++) {
        let clientWidth
        if (options[j].elm && options[j].elm.clientWidth) {
          clientWidth = options[j].elm.clientWidth
        } else {
          const html = this.DOMParser.parseFromString(
            `<span style="display: flex">${options[j].elm.outerHTML}</span>`,
            'text/html'
          )
          let dom = this.$parent.$el.appendChild(html.body.firstChild)
          clientWidth = dom.querySelector('.radio').clientWidth
          this.$parent.$el.removeChild(dom)
          dom = null
        }
        if (clientWidth > level2) {
          classVertical = 'onerow'
          break
        } else if (clientWidth > levelAll) {
          classVertical = this.hideTwoRow ? 'onerow' : 'tworow'
        }
      }
      this.classVertical = classVertical
    },
  },
  //   mounted() {
  //     this.$nextTick(() => {
  //       this.autoOptionHeight()
  //     })
  //   },
  mounted() {
    if (this.oneRow) {
      this.classVertical = 'onerow'
    }
  },
}
</script>
      
      <style scoped>
.option {
  display: flex;
  flex-wrap: wrap;
}
.onerow,
.tworow {
  flex-wrap: wrap;
}
.onerow > * {
  width: 100%;
}
.onerow > .radio {
  margin-right: 0 !important;
}
.tworow > * {
  width: calc(50% - 20px);
}
.allrow > * {
  flex: 1;
}
</style>
      
    


// WEBPACK FOOTER //
// src/ui/components/radio/radio-auto.vue